import * as cost from './Cost';

export const formatCost = cost.formatCost;
export default cost.default;



// WEBPACK FOOTER //
// ./src/common/components/Cost/index.js